// extracted by mini-css-extract-plugin
export var hideEditor = "_ry-2";
export var infoIcon = "_ry-3";
export var label = "_ry-1";
export var labelContainer = "_ry-0";
export var readonlyText = "_ry-4";